import GA4Utilities from './utils/ga4-utilities';
import { SiteUtilities, LocationUtilities } from './utils';

const init = (id) => {
  if (!id) return;
  const rootNode = $('[data-form-section=' + id + ']')[0];
  const section = $(rootNode);
  const jwtTokenElement = section.find('.google-jwt-token');

  // event listener for switching to next step
  section.find('[data-action^="goto-step-"]').on('click', function () {
    const currentStep = rootNode.getAttribute('data-active-form');
    const nextStep = (this.getAttribute('data-action') || '').split('-')[2];

    jwtTokenElement.val('');
    if (!currentStep || !nextStep) return;
    if (nextStep === 'single' || nextStep === 'open') GA4Utilities.googleSSOEvent('Signup_Option_Chooser', 'Normal Signup', 'Option Successfully Chosen');
    toggleSection(section, '.' + currentStep, '.form-step-' + nextStep);
  });
};

const gdprCheckbox = '.gdpr.form-field input[name="send_promotions"]';
$(gdprCheckbox).on('click', function (e) {
  const form = $(e.target).parents('.fw-form');
  const ufx = form.find('ufx-sso-button');
  const gdprFormField = form.find('.gdpr.form-field');
  if ($(e.target).is(':checked')) {
    ufx.attr('disabled', false);
    if (gdprFormField) {
      $(e.target).attr('aria-invalid', 'false').parents('.fw-form').find('.gdpr.form-field').removeClass('error');
    }
  } else {
    ufx.attr('disabled', true);
    if (gdprFormField) {
      $(e.target).attr('aria-invalid', 'true').parents('.fw-form').find('.gdpr.form-field').addClass('error');
    }
  }
});

const googleCallbackInitialization = (id, className, submitHandler, product) => {
  let currentLocation;
  LocationUtilities.onLocationReady(function (geoLocation) {
    currentLocation = geoLocation.continent.code;
    const isGdpr = currentLocation === 'EU' || $('.eu-extra-info.exclude-region-check').length;
    if (!id) return;
    const sectionId = 'my-google-signup-' + id;
    if (!window.ufxSsoButtonConfig) window.ufxSsoButtonConfig = {};
    const section = $($('[data-form-section=' + id + ']')[0]);
    const formElement = section.find('form')[0];
    const jwtTokenElement = section.find('.google-jwt-token');
    const errorObj = {};
    section.find('[data-err-provider=google').each(function () {
      const errorCode = $(this).attr('name');
      const errorMessage = $(this).val();
      if (errorCode && errorMessage) errorObj[errorCode] = errorMessage;
    });

    const googleSsoContainer = $(section.find('[data-sso-provider=google]')[0]);
    const isLinkedAccountsEnabled = $(formElement).data('linked-accounts');

    if (isLinkedAccountsEnabled) {
      const $backLink = section.find('.form-step-domain-list > .domain-list-back-link');
      $backLink.on('click', function () {
        GA4Utilities.postGAEvent('Linked Accounts ignored', 'Google SSO', 'Back', '', 'Linked Accounts');
      });
    }

    window.ufxSsoButtonConfig[sectionId] = {
      onRendered: () => {
        jwtTokenElement.val('');
        // console.log('Signup with Google button is rendered - ' + sectionId);
      },
      onClickWhenDisabled: (e) => {
        const ssoGdprFormField = $(e.target).parents('.fw-form').find('.gdpr.form-field');
        if (ssoGdprFormField) {
          $(e.target).attr('aria-invalid', 'true').parents('.fw-form').find('.gdpr.form-field').addClass('error');
          if (!ssoGdprFormField.find('.checkbox-wrapper').find('.error-wrapper .error').length) {
            ssoGdprFormField.find('.checkbox-wrapper').find('.error-wrapper').append(`<em id="send_promotions-error" class="error">${$(gdprCheckbox).data('gdpr-consent-error')}</em>`);
            ssoGdprFormField.find('.checkbox-wrapper').find('input').trigger('focus');
          }
        }

        // ga4 events
        if (!$(e.target).parents('form').find(gdprCheckbox).is(':checked')) {
          GA4Utilities.postGAEvent('ConsentCheckboxExperiment', 'Consent', 'False', '', 'EUFormsCheckbox');
        }
      },
      beforeAuthentication: () => {
        // console.log('The user just clicked the Signup with Google Button - ' + sectionId);
        SiteUtilities.captureFormInitiateTime();
        GA4Utilities.googleSSOEvent('Signup_Option_Chooser', 'Google SSO', 'Option Successfully Chosen');
      },
      onAuthenticationFailed: (error) => {
        const { errorCode } = error || {};
        if (errorCode === 'USER_CONSENT_DENIED') {
          GA4Utilities.googleSSOEvent('SSO_Form_Google_Account_chooser_screen', 'Google SSO', 'Close');
          return;
        }
        const errMsg = (errorCode && errorObj[errorCode]);
        setTimeout(function () {
          gotoErrorState(section, errMsg);
          GA4Utilities.googleSSOEvent('SSO_Form_Google_Account_chooser_screen', 'Google SSO', 'Close');
        }, 10);
      },
      onAuthenticationSuccess: (res) => {
        if (res && res.data) {
          const { data: { jwtToken, userDetails: { firstName, lastName, email } = {} } = {} } = res;

          const sanitizeName = name => ((typeof name === 'string') && name.replace(/\./g, '')) || '';
          const iterateObject = {
            'first-name': sanitizeName(firstName),
            'last-name': sanitizeName(lastName),
            email: email || ''
          };
          const buttonLoad = googleSsoContainer.find('.button--loading');
          const currentState = `.${section.attr('data-active-form')}`;

          const isPersonalMail = getSocialsName(iterateObject.email) === 'GOOGLE';
          if (!isPersonalMail) iterateObject.company = getComanyNameFromGmail(iterateObject.email) || 'To Be Determined';

          jwtTokenElement.val(jwtToken || '');

          for (const name in iterateObject) {
            if (!prefillForm(section, name, iterateObject[name])) {
              jwtTokenElement.val('');
              return;
            }
          }

          if (isLinkedAccountsEnabled) {
            const signUpUrl = $(formElement).data('signup-url');
            let region = 'US';
            switch (true) {
              case /aloha-in/.test(signUpUrl):
                region = 'IN';
                break;
              case /aloha-eu/.test(signUpUrl):
                region = 'EU';
                break;
              case /aloha-au/.test(signUpUrl):
                region = 'AU';
                break;
            }
            buttonLoad.show();
            SiteUtilities.getLinkedAccounts(product, region, jwtToken).then(accountsData => {
              buttonLoad.hide();
              if (parseInt(accountsData.total_size) > 0 && accountsData.accounts) {
                renderLinkedAccounts(accountsData.accounts, firstName, section, product);
                toggleSection(section, currentState, '.form-step-domain-list');
                GA4Utilities.postGAEvent('Linked Accounts screen', 'Google SSO', 'Linked Accounts Screen', '', 'Linked Accounts');
                attachEmailSignupListener(
                  section,
                  { submitHandler, className, formElement },
                  isPersonalMail,
                  iterateObject,
                  googleSsoContainer,
                  '.form-step-domain-list'
                );
              } else { // skip to regular signup if linked accounts are empty
                attachEmailSignupListener(
                  section,
                  { submitHandler, className, formElement },
                  isPersonalMail,
                  iterateObject,
                  googleSsoContainer,
                  currentState
                );
              }
            }).catch(() => {
              // As a safety net, proceed to signup
              // if linked account lambda fails for some reason
              attachEmailSignupListener(
                section,
                { submitHandler, className, formElement },
                isPersonalMail,
                iterateObject,
                googleSsoContainer,
                currentState
              );
            });
          } else {
            attachEmailSignupListener(
              section,
              { submitHandler, className, formElement },
              isPersonalMail,
              iterateObject,
              googleSsoContainer,
              currentState
            );
          }
        }
      }
    };

    // BTN'S MAX-WIDTH is 400px
    const formWidth = section.find('input[name=email]').innerWidth();
    const windowWidth = $(window).width();
    let btnWidth = null;
    if (formWidth && formWidth < 398) btnWidth = formWidth + 2;
    else if (windowWidth && windowWidth < 430) btnWidth = windowWidth - 30;

    googleSsoContainer.append(
      '<ufx-sso-button id=' + sectionId + ' data-action-type="SIGNUP" ' + (
        btnWidth ? `width=${btnWidth}` : '') + ' style="margin: 0 auto;" data-idp="GOOGLE" label-type="signup_with" locale="' + (googleSsoContainer.data('lang-code') || 'en') + '"></ufx-sso-button>');

    if (isGdpr) {
      googleSsoContainer.find('ufx-sso-button').attr('disabled', 'true');
    }
  });
};

const handleGoogleSingupErrHandler = (section, JWTToken) => {
  if (!section) return;
  const activeForm = section.attr('data-active-form');
  const buttonLoad = $(section.find('[data-sso-provider=google]')[0]).find('.button--loading');
  if ((activeForm === 'form-step-first' || activeForm === 'form-step-open') && JWTToken && JWTToken.length) {
    buttonLoad.hide();
    gotoErrorState(section, '', activeForm);
  } else if (activeForm === 'form-step-domain-list') {
    buttonLoad.hide();
    section.find('#new-account-button').removeClass('button--loading').html('Retry');
  }
};

function prefillForm (section, name, value) {
  if (!section || !name || !value) return;
  const element = section.find('input[name=' + name + ']');
  element.val(value).addClass('field-fix');
  $(element).siblings('label').addClass('placeholder-fix');
  SiteUtilities.additionalGenericFields(element, section);
  return $(element).valid();
}

function getSocialsName (email) {
  return (email && (email.indexOf('@gmail.com') > 0)) ? 'GOOGLE' : null;
}

function gotoErrorState (section, errMsg, currentState) {
  if (!section) return;
  $(section.find('.form-step-error-state .error-label')[0]).text(errMsg || 'We are unable to sign you up at this moment. Please try again in some time');
  toggleSection(section, `.${currentState}`, '.form-step-error-state');
}

function toggleSection (section, before, after) {
  if (!section || !before || !after) return;
  section.find(before).addClass('inactive').attr({
    'aria-hidden': 'true',
    tabindex: -1
  });
  section.find(after).removeClass('inactive').attr({
    'aria-hidden': 'false',
    tabindex: 0
  });
  section.attr('data-active-form', after.substr(1));
  if (after === '.form-step-open') {
    section.find(after).parent().removeClass('inactive');
  }
  if (after === '.form-step-first') {
    section.find('.open-fields').addClass('inactive').attr({
      'aria-hidden': 'true',
      tabindex: -1
    });
  }
}

function getComanyNameFromGmail (gmailId) {
  if (!gmailId) return null;
  const startPos = gmailId.indexOf('@') + 1;
  if (startPos < 1) return null;
  const endPos = gmailId.substr(startPos).indexOf('.');
  if (endPos < 1) return null;
  return gmailId.substr(startPos, endPos) || null;
}

function renderLinkedAccounts (accounts, firstName, section, product) {
  const listTemplate = info => {
    const productType = info.bundle_identifier ? 'fdeskOmni' : product;
    const iconData = SiteUtilities.getProductIconInfo(productType);
    return `<a class="domain-list-card" href="${info.account_href}">
      <img src="${iconData.src}" class="icon" alt="${iconData.alt}">
      <div class="domain-info">
        <p class="account-name"><strong>${info.name}</strong></p>
        <p class="account-domain-name">${info.domain}</p>
        <p class="account-last-login">Last login ${new Date(info.last_login_at).toDateString()}</p>
      </div>
      <i class="icon-arrow-button-right"></i>
    </a>`;
  };

  const $firstName = section.find('.form-step-domain-list > .welcome-message');
  const $cardWrapper = section.find('.form-step-domain-list.card-wrapper');
  $firstName.html(
    $firstName.html().replace('&lt;&lt;&gt;&gt;', firstName)
  );

  const nodes = accounts.map(listTemplate);
  $cardWrapper.find('.domain-list-card').remove(); // refresh card list
  $cardWrapper.prepend(nodes);
  // Intercept a tag's click event to post GA event
  $cardWrapper.find('.domain-list-card').on('click', function (e) {
    e.preventDefault();
    const host = $(this).find('.account-domain-name').html();
    GA4Utilities.postGAEvent('Linked Accounts chosen', 'Google SSO', host, '', 'Linked Accounts');
    window.location.href = this.href;
  });
}

function attachEmailSignupListener (
  section,
  formParams,
  isPersonalMail,
  iterateObject,
  googleSsoContainer,
  state
) {
  const { formElement, className, submitHandler } = formParams;
  const $newAccontButton = section.find('.form-step-domain-list > #new-account-button');

  $newAccontButton.removeClass('button--loading');
  $newAccontButton.unbind('click');
  const handler = state => {
    $newAccontButton.addClass('button--loading');
    if (isPersonalMail) {
      $(section.find('.embed-user-info').find('.data-label')[0]).text(iterateObject.email);
      setTimeout(function () {
        toggleSection(section, state, '.form-step-second');
        GA4Utilities.googleSSOEvent('SSO_Form_Google_Account_chooser_screen', 'Google SSO', 'Generic');
      }, 10);
    } else {
      section.find('.phone-form').val(null);
      if (submitHandler && className && formElement) {
        googleSsoContainer.find('.button--loading').show();
        submitHandler(className, formElement);
        GA4Utilities.googleSSOEvent('SSO_Form_Google_Account_chooser_screen', 'Google SSO', 'Business');
      }
    }
  };
  // defer submitting form for domain listing state and attach submit event to create new account button
  if (state === '.form-step-domain-list') {
    return $newAccontButton.on('click', function () {
      GA4Utilities.postGAEvent('Linked Accounts ignored', 'Google SSO', 'Create new account', '', 'Linked Accounts');
      handler(state);
    });
  }
  handler(state);
}

export default { init, googleCallbackInitialization, handleGoogleSingupErrHandler };
